import React from "react";
import { t } from "locales";
import useModalLinkPrinter from "hooks/useModalLinkPrinter";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import FullWidthPageBackground from "components/FullWidthPageBackground";
import "./style.scss";

export default function BlockRecommendationToContactUs() {
  const { getLocation } = useModalLinkPrinter();
  return (
    <div className="block-recommendation-to-contact-us text-center py-6">
      <FullWidthPageBackground className="block-recommendation-to-contact-us__background" />
      <div className="block-recommendation-to-contact-us__content d-flex __column __align-center">
        <div className="caption-1 fw-bold text-center mb-5">
          {t("Not sure who’s right for you? Contact us — we’ll recommend a coach.")}
        </div>

        <BaseButton
          className="block-recommendation-to-contact-us__btn body-big fw-bold pl-4 pr-3"
          to={getLocation("/contact-us")}
          large
          borderless
        >
          {t("Contact Us")}
          <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
        </BaseButton>
      </div>
    </div>
  );
}
